import React, { useState, useEffect } from "react";
import {
  Card, CardContent, CardHeader, TextField, MenuItem, Grid,
  Typography, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Button, Dialog, DialogTitle, DialogContent,
  DialogActions
} from "@mui/material";
import { toast } from "react-toastify";
import config from "../../config";
export default function PackageReport() {
  const [hotels, setHotels] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState("");
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [loadingHotels, setLoadingHotels] = useState(true);
  const [loadingRoomTypes, setLoadingRoomTypes] = useState(false);
const company = JSON.parse(sessionStorage.getItem("companyDetails"));
  // Detail modal
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedPackageDetails, setSelectedPackageDetails] = useState([]);

  // 🔹 Update modal state
  const [openUpdate, setOpenUpdate] = useState(false);
  const [editData, setEditData] = useState({
    packageId: "",
    packageName: "",
    description: "",
    fromDate: "",
    toDate: "",
   weekType: "",
  memberWisePrices: []   
  });
  const url = `${config.API_BASE_URL}${config.PRODUCT_LIST_API}`;
  // Fetch hotels
  useEffect(() => {
    const fetchHotels = async () => {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      try {
        const res = await fetch(`${config.API_BASE_URL}/Home/GetHotelsdropdown/${encodeURIComponent(company?.id)}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch hotels");
        setHotels(await res.json());
      } catch (err) {
        console.error("Error fetching hotels:", err);
      }
      setLoadingHotels(false);
    };
    fetchHotels();
  }, []);

  // Fetch room types
  useEffect(() => {
    const fetchRoomTypes = async () => {
      setLoadingRoomTypes(true);
      const token = sessionStorage.getItem("token");

      try {
        const res = await fetch(`${config.API_BASE_URL}/Home/GetAllRoomType/${encodeURIComponent(company?.id)}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch room types");
        setRoomTypes(await res.json());
      } catch (err) {
        toast.error("Failed to fetch room types");
      }
      setLoadingRoomTypes(false);
    };
    fetchRoomTypes();
  }, []);

  // Fetch packages
  useEffect(() => {
    debugger;
    if (selectedHotel && selectedRoomType) {
      const fetchPackages = async () => {
        const token = sessionStorage.getItem("token");
        try {
          const res = await fetch(
            `${config.API_BASE_URL}/Home/GetPackageReport?hotelId=${selectedHotel}&roomTypeId=${selectedRoomType}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          if (!res.ok) throw new Error("Failed to fetch packages");
          const data = await res.json();
        console.log(data);  // 👈 Correct print
        setPackages(data);
        } catch (err) {
          setPackages([]);
        }
      };
      fetchPackages();
    }
  }, [selectedHotel, selectedRoomType]);

  // View details
  const handleOpenDetails = (pkg) => {
    setSelectedPackageDetails(pkg.memberWisePrices || []);
    setOpenDetails(true);
  };
const handleDeactivate = async (packageId) => {
  if (!window.confirm("Are you sure you want to deactivate this package?")) return;

  const token = sessionStorage.getItem("token");
  try {
    const res = await fetch(
      `${config.API_BASE_URL}/Home/Deactivepackage/${packageId}`, // 👈 Updated
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw new Error("Failed to deactivate package");
 
    toast.success("Package deactivated successfully!");
    window.location.reload();
    // Refresh data
    setSelectedRoomType(selectedRoomType);
  } catch (err) {
    toast.error("Error deactivating package");
  }
};

const handlePriceChange = (index, field, value) => {
  const updatedPrices = [...editData.memberWisePrices];
  updatedPrices[index] = {
    ...updatedPrices[index],
    [field]: value
  };

  setEditData({
    ...editData,
    memberWisePrices: updatedPrices
  });
};

  const handleCloseDetails = () => {
    setOpenDetails(false);
    setSelectedPackageDetails([]);
  };

  // 🔹 Open Update popup
  const handleOpenUpdate = (pkg) => {
    setEditData({
      packageId: pkg.packageId,
      packageName: pkg.packageName,
      description: pkg.description,
      fromDate: pkg.fromDate?.split("T")[0],
      toDate: pkg.todate?.split("T")[0],
      weekType: pkg.weakType,
        memberWisePrices: pkg.memberWisePrices || []
    });
    setOpenUpdate(true);
  };

  const handleUpdateChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  // 🔹 Save update
  const handleUpdateSave = async () => {
    debugger;
    const token = sessionStorage.getItem("token");

    try {
     const res = await fetch(`${config.API_BASE_URL}/Home/UpdatePackage`, {
  method: "POST", // 👈 Change this
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(editData),
});

      if (!res.ok) throw new Error("Update failed");

      toast.success("Package updated successfully!");
      setOpenUpdate(false);
      window.location.reload();
      // Refresh list
      setSelectedRoomType(selectedRoomType);
    } catch (err) {
      toast.error("Error updating package");
    }
  };

  return (
    <>
      {/* Filter card */}
      <Card sx={{ margin: "30px auto", padding: 3, maxWidth: "90%" }}>
        <CardHeader title="Package Report" sx={{ fontWeight: "bold" }} />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item>
              <TextField select label="Select Hotel" value={selectedHotel} onChange={(e) => {
                setSelectedHotel(e.target.value);
                setSelectedRoomType("");
              }} disabled={loadingHotels} sx={{ minWidth: 250 }}>
                <MenuItem value="">-- Select --</MenuItem>
                {hotels.map((h) => (
                  <MenuItem key={h.id} value={h.id}>
                    {h.hotelName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item>
              <TextField select label="Select Room Type" value={selectedRoomType} disabled={!selectedHotel} onChange={(e) => setSelectedRoomType(e.target.value)} sx={{ minWidth: 250 }}>
                <MenuItem value="">-- Select --</MenuItem>
                {roomTypes.map((r) => (
                  <MenuItem key={r.id} value={r.id}>{r.roomtype}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table */}
      {packages.length > 0 && (
        <Card sx={{ margin: "30px auto", padding: 3, maxWidth: "90%" }}>
          <CardHeader title="Available Packages" sx={{ fontWeight: "bold" }} />
          <CardContent>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Hotel Name</TableCell>
                    <TableCell>Room Type</TableCell>
                    <TableCell>Package Name</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>From Date</TableCell>
                    <TableCell>To Date</TableCell>
                    <TableCell>Week Type</TableCell>
                    <TableCell align="center">Details</TableCell>
                    <TableCell align="center">Update</TableCell>
                     <TableCell align="center">Deactive</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {packages.map((pkg, i) => (
                    <TableRow key={i}>
                      <TableCell>{pkg.hotelName}</TableCell>
                      <TableCell>{pkg.roomType}</TableCell>
                      <TableCell>{pkg.packageName}</TableCell>
                      <TableCell>{pkg.description}</TableCell>
                      <TableCell>{new Date(pkg.fromDate).toLocaleDateString('en-GB')}</TableCell>
                      <TableCell>{new Date(pkg.todate).toLocaleDateString('en-GB')}</TableCell>
                      <TableCell>{pkg.weakType}</TableCell>
                      <TableCell align="center">
                        <Button variant="contained" size="small" onClick={() => handleOpenDetails(pkg)}>View</Button>
                      </TableCell>
                      <TableCell align="center">
                        <Button variant="outlined" size="small" onClick={() => handleOpenUpdate(pkg)}>Update</Button>
                          
                      </TableCell>
<TableCell align="center">
  {pkg.isactive === true ? (
    <Button
      variant="contained"
      color="error"
      size="small"
      sx={{ ml: 1 }}
      onClick={() => handleDeactivate(pkg.packageId)}
    >
      Deactivate
    </Button>
  ) : (
    <span style={{ color: "gray", fontWeight: "500" }}>Deactivated</span>
  )}
</TableCell>



                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* 🔹 Update Modal */}
      <Dialog open={openUpdate} onClose={() => setOpenUpdate(false)} fullWidth maxWidth="sm">
        <DialogTitle>Update Package</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Package Name" name="packageName"
            margin="dense" value={editData.packageName} onChange={handleUpdateChange} />

          <TextField fullWidth label="Description" name="description"
            margin="dense" value={editData.description} onChange={handleUpdateChange} />

          <TextField fullWidth type="date" label="From Date" name="fromDate"
            margin="dense" InputLabelProps={{ shrink: true }} value={editData.fromDate} onChange={handleUpdateChange} />

          <TextField fullWidth type="date" label="To Date" name="toDate"
            margin="dense" InputLabelProps={{ shrink: true }} value={editData.toDate} onChange={handleUpdateChange} />

          <TextField select fullWidth label="Week Type" name="weekType"
            margin="dense" value={editData.weekType} onChange={handleUpdateChange}>
            <MenuItem value="Weekend">Weekend</MenuItem>
            <MenuItem value="Weekday">Weekday</MenuItem>
          </TextField>

          <Typography sx={{ mt: 2, fontWeight: "bold" }}>
  Member Wise Prices
</Typography>

{editData.memberWisePrices.map((price, index) => (
  <Grid container spacing={2} key={index} sx={{ mt: 1 }}>
    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Adults"
        value={price.adultCount}
        onChange={(e) =>
          handlePriceChange(index, "adultCount", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Children"
        value={price.childCount}
        onChange={(e) =>
          handlePriceChange(index, "childCount", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Child Age"
        value={price.childAge}
        onChange={(e) =>
          handlePriceChange(index, "childAge", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={3}>
      <TextField
        fullWidth
        label="Price"
        type="number"
        value={price.price}
        onChange={(e) =>
          handlePriceChange(index, "price", e.target.value)
        }
      />
    </Grid>
  </Grid>
))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenUpdate(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleUpdateSave}>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Details Modal */}
      <Dialog open={openDetails} onClose={handleCloseDetails} maxWidth="sm" fullWidth>
        <DialogTitle>Member-wise Price Details</DialogTitle>
        <DialogContent>
          {selectedPackageDetails.length > 0 ? (
            <Table size="small">
              <TableHead><TableRow><TableCell>Adults</TableCell><TableCell>Children</TableCell><TableCell>Age</TableCell><TableCell>Price</TableCell></TableRow></TableHead>
              <TableBody>
                {selectedPackageDetails.map((d, i) => (
                  <TableRow key={i}><TableCell>{d.adultCount}</TableCell><TableCell>{d.childCount}</TableCell><TableCell>{d.childAge}</TableCell><TableCell>{d.price}</TableCell></TableRow>
                ))}
              </TableBody>
            </Table>
          ) : <Typography>No Data</Typography>}
        </DialogContent>
        <DialogActions><Button onClick={handleCloseDetails}>Close</Button></DialogActions>
      </Dialog>
    </>
  );
}
